import { render, staticRenderFns } from "./SimpleUploaderS3.vue?vue&type=template&id=705ce52f&"
import script from "./SimpleUploaderS3.vue?vue&type=script&lang=js&"
export * from "./SimpleUploaderS3.vue?vue&type=script&lang=js&"
import style0 from "./SimpleUploaderS3.vue?vue&type=style&index=0&id=705ce52f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports